export const TOPICS = {
    PORTS: "PORTS",
    SYSTEM: "SYSTEM",
    NETWORK_INTERFACES: "NETWORK_INTERFACES",
    PROCESSES: "PROCESSES",
    SYSTEM_PACKAGES: "SYSTEM_PACKAGES",
    APPLICATIONS: "APPLICATIONS",
    UNINSTALL_APP: "UNINSTALL_APP",
    EXECUTE_COMMAND: "EXECUTE_COMMAND",
    DEVICES: "DEVICES",
    ALL_APPS: "ALL_APPS",
    CONNECTION: "CONNECTION",
    EXECUTE_RESPONSE: "EXECUTE_RESPONSE",
    USERS: "USERS",
    KILL_PORT_RESPONSE: "KILL_PORT_RESPONSE",
    KILL_PROCESS_RESPONSE: "KILL_PROCESS_RESPONSE",
    USER_ACTIONS: "USER_ACTIONS",
    UPDATE_RELEASE: "UPDATE_RELEASE",
    CMD_LINUX_TOPIC :"CONSOLE_COMMAND",
    CMD_LINUX_OUT_TOPIC: "CONSOLE_RESPONSE"
}


export const DeviceStatus = {
    registered: "Registered",
    connected: "Connected",
    disconnected: "Disconnected",
    activated: "Activated",
    add_credentials: "Add Credentials",
    verified: "Verified",
    verifying: "Verifying",
    partialConnected: "Partially Connected",
    reScanning: "Re-Scanning",
    quarantine: "Quarantine"
}

export const OS = {
    windows: "Windows",
    ubuntu: "Ubuntu"
}

export const SUBSCRIPTION_STATUS = {
    active: "active",
    canceled: "canceled",
    incomplete_expired: "incomplete_expired",
    incomplete: "incomplete",
    trialing: "trialing",
    past_due: "past_due",
    unpaid: "unpaid",
    paused: "paused",
    expired: "expired",
    failed: "failed",
    pending: "pending"
};


export const PAYMENT_PLANS = {
    BASIC_CLOUD: "Basic Cloud",
    PROFESSIONAL_CLOUD: "Professional Cloud",
    ENTERPRISE_CLOUD: "Enterprise Cloud",
    CUSTOM_CLOUD: "Custom Cloud"
}